export const checkIsOutdated = (lastUpdateTimestamp) => {
  const days = 1000 * 60 * 60 * 24;
  const maxDayDiff = 1;
  const dayOne = new Date(lastUpdateTimestamp);
  const dayTwo = new Date();
  const timediff = dayTwo - dayOne;
  const diffInDays = Math.round(timediff / days);
  return diffInDays > maxDayDiff ? false : true;
};
